import React from 'react';
import PropTypes from 'prop-types';

import {connect} from 'react-redux';
import {setUiBreadcrumbs, setUiMenuTaxon} from '../../ducks/ui';


@connect()
export default class LocationDispatchingSink extends React.PureComponent {
  static propTypes = {
    breadcrumbs: PropTypes.any,
    menuTaxon: PropTypes.string
  };

  componentWillMount() {
    const {dispatch, breadcrumbs, menuTaxon} = this.props;

    if (breadcrumbs) {
      dispatch(setUiBreadcrumbs(breadcrumbs));
    }

    if (menuTaxon) {
      dispatch(setUiMenuTaxon(menuTaxon));
    }
  }

  componentDidUpdate(prevProps) {
    const {dispatch, breadcrumbs, menuTaxon} = this.props;

    if (breadcrumbs && breadcrumbs !== prevProps.breadcrumbs) {
      dispatch(setUiBreadcrumbs(breadcrumbs));
    }

    if (menuTaxon && menuTaxon !== prevProps.menuTaxon) {
      dispatch(setUiMenuTaxon(menuTaxon));
    }
  }

  render() {
    return false;
  }
}



// WEBPACK FOOTER //
// ./containers/locationDispatchingSink/LocationDispatchingSink.js